import { useReducer, useEffect } from 'react';
const WindowSizeReducer = (state, action) => {
    switch (action.type) {
        case 'mobile':
            return Object.assign(Object.assign({}, state), { isMobile: action.state });
        case 'tabletPortrait':
            return Object.assign(Object.assign({}, state), { isTabletPortrait: action.state });
        case 'tabletLandscape':
            return Object.assign(Object.assign({}, state), { isTabletLandscape: action.state });
        case 'desktop':
            return Object.assign(Object.assign({}, state), { isDesktop: action.state });
        default:
            return state;
    }
};
const getWindowSizeState = () => {
    const isMobile = window.innerWidth < 768;
    const isTabletPortrait = window.innerWidth >= 768 && window.innerWidth < 1024;
    const isTabletLandscape = window.innerWidth >= 1024 && window.innerWidth < 1200;
    const isDesktop = window.innerWidth >= 1200;
    return { isMobile, isTabletPortrait, isTabletLandscape, isDesktop };
};
export const useWindowSize = () => {
    const [state, dispatch] = useReducer(WindowSizeReducer, null, getWindowSizeState);
    const setWindowSizeState = () => {
        const { isMobile, isTabletPortrait, isTabletLandscape, isDesktop } = getWindowSizeState();
        dispatch({ type: 'mobile', state: isMobile });
        dispatch({ type: 'tabletPortrait', state: isTabletPortrait });
        dispatch({ type: 'tabletLandscape', state: isTabletLandscape });
        dispatch({ type: 'desktop', state: isDesktop });
    };
    useEffect(() => {
        window.addEventListener('resize', setWindowSizeState);
        return () => {
            window.removeEventListener('resize', setWindowSizeState);
        };
    }, []);
    return state;
};
